import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n-lite';
import { connect } from 'react-redux';
import { Warning, Title, DesyncButton } from './DesynchronizeComponents';

import DropDownContainer from './DropDownContainer';

import { DESYNCHRONIZE_BOOK_REVEAL } from '../../book/desynchronizeBook/DesynchronizeBookReveal';
import { bindActionCreators } from 'redux';

import * as revealActions from '../../../actions/revealActions';
import AssignedClassrooms from './AssignedClassrooms';

class LinkedBooksDropDown extends Component {
  openReveal = () => {
    const { revealActions } = this.props;

    revealActions.setOpenReveal(DESYNCHRONIZE_BOOK_REVEAL);
  };

  render() {
    const { dangerColor, synchronizedClassrooms, activeClassrooms, disableUnlinkContent } = this.props;

    return (
      <DropDownContainer>
        <Title>{I18n.t('bookContainer.classroomSynchronizedContent')}</Title>
        <AssignedClassrooms synchronizedClassrooms={synchronizedClassrooms} activeClassrooms={activeClassrooms} />
        <Warning>{I18n.t('bookContainer.classroomSynchronizedWarning')}</Warning>
        {!disableUnlinkContent && (
          <DesyncButton dangerColor={dangerColor} onClick={this.openReveal}>
            <div>{I18n.t('bookContainer.desynchronize')}</div>
          </DesyncButton>
        )}
      </DropDownContainer>
    );
  }
}

LinkedBooksDropDown.propTypes = {
  dangerColor: PropTypes.string,
  activeClassrooms: PropTypes.array,
  revealActions: PropTypes.object,
  synchronizedClassrooms: PropTypes.array
};

const mapStateToProps = state => ({
  activeClassrooms: state.classrooms.activeClassrooms,
  dangerColor: state.theme.colors.btnDanger,
  disableUnlinkContent: state.account.configuration.disableUnlinkContent
});

const mapDispatchToProps = dispatch => ({ revealActions: bindActionCreators(revealActions, dispatch) });

export default connect(mapStateToProps, mapDispatchToProps)(LinkedBooksDropDown);
